import { Action as ReduxAction } from 'redux';
import { RidiState } from 'src/app/common/ridi.store/ridi.reducer';

// Base Action
export interface Action<T extends string, P = undefined> extends ReduxAction {
  type: T;
  payload?: P;
}

export enum ActionKeys {
  INITIALIZE_RIDI = 'INITIALIZE_RIDI',
  OTHER_ACTION = '__any_other_action_type__',
}

export interface ActionInitializeRidi {
  type: ActionKeys.INITIALIZE_RIDI;
  payload: RidiState;
}

interface ActionOthers {
  type: ActionKeys.OTHER_ACTION;
}

export type ActionTypes = ActionOthers | ActionInitializeRidi;

export interface Platform {
  type: 'mobile' | 'pc' | 'tablet' | 'paper' | 'ridi_app' | 'unknown';
  isPc: boolean;
  isTablet: boolean;
  isMobile: boolean;
  isPaper: boolean;
  isPaperPro: boolean;
  isRidiApp: boolean;
}

export interface Auth {
  isLoggedIn: boolean;
}

export interface Constants {
  apiUrl: string;
  notificationApiUrl: string;
  apiToken: string;
  sslHostLink: string;
  miscUrl: string;
  staticUrl: string;
}

export interface Context {
  ridiAppTheme: string;
  isNotUseNotificationCenter: false; // base_freebook_inapp.t.twig 이외에 사용 금지
}

export interface RidiStoreDTO {
  platform: Platform;
  auth: Auth;
  constants: Constants;
  context: Context;
}

export function initializeRidi(ridiDTO: RidiState): ActionInitializeRidi {
  return {
    payload: ridiDTO,
    type: ActionKeys.INITIALIZE_RIDI,
  };
}



// WEBPACK FOOTER //
// ./common/ridi.store/ridi.actions.ts